export class RegistrationExhibition {
    registrationId: number;
    exhibitionId: number;
    entryCount: number;
}


// WEBPACK FOOTER //
// ./src/model/registrationExhibition.ts